import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const PresetsItemsSectionBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginBottom: '24px',
});
